import React from 'react';
import Header from '../components/Header';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import { Users, ExternalLink } from 'lucide-react';

const Statutory = () => {
  const committees = [
    {
      name: 'Internal Quality Assurance Cell (IQAC)',
      members: [
        { name: 'Dr. S. V. Shinde', position: 'Chairperson' },
        { name: 'Prof. A. B. Patil', position: 'Coordinator' },
        { name: 'Prof. M. R. Desai', position: 'Member' },
        { name: 'Prof. R. S. Kulkarni', position: 'Member' }
      ]
    },
    {
      name: 'Internal Complaints Committee (ICC)',
      members: [
        { name: 'Prof. N. A. Pawar', position: 'Presiding Officer' },
        { name: 'Prof. S. K. Jadhav', position: 'Member' },
        { name: 'Prof. P. D. Mane', position: 'Member' },
        { name: 'External Member', position: 'NGO Representative' }
      ]
    },
    {
      name: 'Anti-Ragging Committee',
      members: [
        { name: 'Dr. S. V. Shinde', position: 'Chairperson' },
        { name: 'Prof. V. B. Kumbhar', position: 'Convenor' },
        { name: 'Prof. A. S. Patil', position: 'Member' },
        { name: 'Student Representative', position: 'Member' }
      ]
    },
    {
      name: 'Grievance Redressal Committee',
      members: [
        { name: 'Dr. S. V. Shinde', position: 'Chairperson' },
        { name: 'Prof. K. L. Shinde', position: 'Convenor' },
        { name: 'Prof. D. B. Patil', position: 'Member' },
        { name: 'Student Representative', position: 'Member' }
      ]
    },
    {
      name: 'SC/ST/OBC Cell',
      members: [
        { name: 'Prof. M. S. Kamble', position: 'Coordinator' },
        { name: 'Prof. R. T. Pawar', position: 'Member' },
        { name: 'Prof. S. D. Jadhav', position: 'Member' }
      ]
    },
    {
      name: 'Women Development Cell',
      members: [
        { name: 'Prof. P. A. Kale', position: 'Coordinator' },
        { name: 'Prof. M. B. Shinde', position: 'Member' },
        { name: 'Prof. N. S. Patil', position: 'Member' }
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <Navigation />
      
      <div className="container mx-auto px-4 py-8">
        <div className="mb-8">
          <h1 className="text-4xl font-bold text-[#000066] mb-2 flex items-center gap-3">
            <Users className="w-10 h-10" />
            Statutory Committees
          </h1>
          <p className="text-gray-600">College committees as per UGC and State Government guidelines</p>
        </div>

        <div className="grid gap-6">
          {committees.map((committee, index) => (
            <div
              key={index}
              className="bg-white rounded-lg shadow-lg p-6 hover:shadow-xl transition-shadow duration-300 border-l-4 border-[#FF4500]"
            >
              <h2 className="text-2xl font-bold text-[#000066] mb-4">
                {committee.name}
              </h2>
              <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
                {committee.members.map((member, idx) => (
                  <div
                    key={idx}
                    className="bg-gradient-to-br from-gray-50 to-gray-100 p-4 rounded-lg"
                  >
                    <p className="font-semibold text-gray-800">{member.name}</p>
                    <p className="text-sm text-gray-600">{member.position}</p>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-8 bg-blue-50 border-l-4 border-blue-500 p-6 rounded">
          <p className="text-gray-700">
            <strong>Note:</strong> For detailed information about committee roles, responsibilities, 
            and contact information, please refer to the{' '}
            <a
              href="https://davcommercesolapur.com/DAV/College%20Committee_Final_2021-22.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 hover:text-blue-800 inline-flex items-center gap-1"
            >
              College Committees Document
              <ExternalLink className="w-4 h-4" />
            </a>
          </p>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default Statutory;
